import { useRouter } from 'next/router';

import { useSibcyListing } from '@lib/sibcy-listing-context';

import { isChatHidden } from './chat-visibility';

export const useChatHidden = () => {
  const { pathname, query } = useRouter();

  const { isSibcyListing } = useSibcyListing();

  return isChatHidden({ pathname, query, isSibcyListing });
};
